import React, {useRef, useState} from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
// import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import CloseIcon from "@mui/icons-material/Close";
import {Controller} from "react-hook-form";
import {Editor} from "@tinymce/tinymce-react";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {useUploadFileMutation} from "../../app/apis/upload.api";
import Stack from '@mui/material/Stack';

export const DocumentRowWrapper = ({children}) => {
  return (
      <Box style={{borderLeft: '8px solid #8CC841', paddingRight: "20px"}}>
        <Box border={{marginLeft: "8px", padding: "10px 10px", borderBottom: "1px solid gray"}}>
          {children}
        </Box>
      </Box>
  )
};

export const SelectFile = ({docUri, name, onChange}) => {
  const {t} = useTranslation();
  const uploadInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [uploadFile] = useUploadFileMutation();

  const onChangeUpload = (e) => {
    let selectedFile = e.target.files[0];
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('uploadType', 'file');


    uploadFile(formData)
        .then((resp) => {
          let uri = resp.data.temporaryLocation.replace('/temp/', '/private/temp/');
          let format = resp.data.format;
          setFile({
            name: selectedFile.name,
            format,
            uri,
          });

          onChange(uri, selectedFile.name, format);
        });
  }

  const onCopyLink = (uri) => {
    navigator.clipboard.writeText(`/api/download/?uri=${uri}`);
  }

  if (docUri) {
    return <Box>
      <a href={`/api/download/?uri=${docUri}`} target={"_blank"} style={{fontSize: 14}}>{name}</a>
      <Box>
        <DeleteOutlineIcon sx={{fontSize: 14, cursor: "pointer"}} onClick={() => {
          setFile(null);
          onChange();
        }}/>
        <ContentCopyIcon sx={{fontSize: 14, cursor: "pointer"}} onClick={() => onCopyLink(docUri)}/>
      </Box>
    </Box>
  }

  return <>
    {file ? <Box>
      <a href={`/api/download/?uri=${file.uri}`} target={"_blank"} style={{fontSize: 14}}>{file.name}</a>
      <Box>
        <DeleteOutlineIcon sx={{fontSize: 14, cursor: "pointer"}}/>
        <ContentCopyIcon sx={{fontSize: 14, cursor: "pointer"}} onClick={() => onCopyLink(file.uri)}/>
      </Box>
    </Box> : <>
      <a onClick={() => uploadInputRef.current.click()} style={{cursor: "pointer"}}> select file <AddIcon
          sx={{fontSize: 14}}/> </a>
      <input
          type='file'
          onChange={onChangeUpload}
          style={{display: 'none'}}
          accept='.doc,.docx,.pdf,.xml,.html,.htm'
          ref={uploadInputRef}
      />
    </>
    }
  </>
}


const DocumentList = ({name, ...restProps}) => {
  const {t} = useTranslation();
  const [documents, setDocuments] = useState([]);

  return (
      <Controller
          name={name}
          render={({field}) => {

            if (field?.value)
              setDocuments(field.value)

            const onFileChang = (uri, name, format, index) => {
              let tmp = [...documents];
              tmp[index] = {...tmp[index], format, uri, desc: [{lang: "en", value: name}]}
              setDocuments(tmp);
              field.onChange(tmp);
            }

            return (
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={4}>
                        DOCUMENT
                      </Grid>
                      <Grid item xs={7}>
                        DESCRIPTION
                      </Grid>
                      <Grid item xs={1}>
                        DELETE
                      </Grid>
                    </Grid>
                  </Grid>
                  {
                    documents.map((e, i) => <Grid item key={i} xs={12} mt={1}>
                      <DocumentRowWrapper>
                        <Grid container>
                          <Grid item xs={4}>
                            <SelectFile
                                docUri={e.uri}
                                name={e.desc?e.desc[0].value : ""}
                                onChange={(uri, name, format) => onFileChang(uri, name, format, i)}/>
                          </Grid>
                          <Grid item xs={7}>
                            <TextField
                                multiline
                                size="small"
                                inputProps={{style: {fontSize: 12}}}
                                sx={{
                                  width: 400,
                                }}
                                value={documents[i]?.narrative ? documents[i]?.narrative[0]?.value : ""}
                                onChange={(e) => {
                                  let tmp = [...documents];
                                  tmp[i] = {
                                    ...tmp[i], narrative: [
                                      {
                                        "lang": "en",
                                        "value": e.target.value
                                      }
                                    ]
                                  }
                                  setDocuments(tmp);
                                  field.onChange(tmp);
                                }}
                            />
                          </Grid>
                          <Grid item xs={1}>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                              <CloseIcon sx={{fontSize: 14, cursor: "pointer"}} onClick={() => {
                                let tmp = [...documents];
                                tmp.splice(i, 1)
                                setDocuments(tmp);
                                field.onChange(tmp);
                              }}/>
                            </Box>
                          </Grid>
                        </Grid>
                      </DocumentRowWrapper>
                    </Grid>)
                  }
                  <Grid item xs={12} mt={1}>
                    <DocumentRowWrapper>
                      <span
                          style={{cursor: "pointer"}}
                          onClick={() => {
                            let tmp = [...documents, {
                              "lang": "en",
                            }];
                            field.onChange(tmp);
                          }}><AddIcon sx={{fontSize: 14}}/> add new line</span>
                    </DocumentRowWrapper>
                  </Grid>
                </Grid>
            )
          }}
      />
  )
};

export default DocumentList;
